import RedQuickCheckboxField from 'components/RedQuickCheckBoxField'
import RedQuickCheckbox from 'components/RedQuickCheckbox'
import RedQuickDatePicker from 'components/RedQuickDatePicker'
import RedQuickDropdown, {
  RedQuickStateProvince,
} from 'components/RedQuickDropdown'
import RedQuickList from 'components/RedQuickList'
import RedQuickTextArea from 'components/RedQuickTextArea'
import RedQuickTextField from 'components/RedQuickTextField'
import Jobs from 'features/jobs/jobs'
import StripeServices from 'features/stripe/services/stripe-services'
import ViewAddProfileComponent from 'features/view/add/profile/component/view-add-profile-component'
import ViewAnonymousSignIn from 'features/view/anonymous/sign/in/view-anonymous-sign-in'
import ViewApiSubtitles from 'features/view/api/subtitles/view-api-subtitles'
import ViewApi from 'features/view/api/view-api'
import ViewApprovalRequests from 'features/view/approval/requests/view-approval-requests'
import ViewContentCreatorInvitationList from 'features/view/content/creator/invitation/list/view-content-creator-invitation-list'
import ViewContentCreatorInvite from 'features/view/content/creator/invite/view-content-creator-invite'
import ViewContentCreatorProfileImage from 'features/view/content/creator/profile/image/view-content-creator-profile-image'
import ViewContentHouseAccessListComponent from 'features/view/content/house/access/list/component/view-content-house-access-list-component'
import ViewContentHouseList from 'features/view/content/house/list/view-content-house-list'
import ViewContentHouseMedia from 'features/view/content/house/media/view-content-house-media'
import ViewContentHouseMembership from 'features/view/content/house/membership/view-content-house-membership'
import ViewContentHouseMyMembership from 'features/view/content/house/my/membership/view-content-house-my-membership'
import ViewContentHouseProfileImage from 'features/view/content/house/profile/image/view-content-house-profile-image'
import ViewContentHouseReleaseManagement from 'features/view/content/house/release/management/view-content-house-release-management'
import ViewContentHouseSeason from 'features/view/content/house/season/view-content-house-season'
import ViewContentHouseSeries from 'features/view/content/house/series/view-content-house-series'
import ViewContentHouseUpdate from 'features/view/content/house/update/view-content-house-update'
import ViewContentHouse from 'features/view/content/house/view-content-house'
import ViewCustomerAdministratorComponent from 'features/view/customer/administrator/component/view-customer-administrator-component'
import ViewCustomerHomePageManagerComponent from 'features/view/customer/home/page/manager/component/view-customer-home-page-manager-component'
import ViewCustomerSettingsComponent from 'features/view/customer/settings/component/view-customer-settings-component'
import ViewEditProfileComponent from 'features/view/edit/profile/component/view-edit-profile-component'
import ViewHomeScreen from 'features/view/home/screen/view-home-screen'
import ViewManageCoherentScreens from 'features/view/manage/coherent/screens/view-manage-coherent-screens'
import ViewManageCuratedMedia from 'features/view/manage/curated/media/view-manage-curated-media'
import ViewManageCuratedSeries from 'features/view/manage/curated/series/view-manage-curated-series'
import ViewManageReleaseZones from 'features/view/manage/release/zones/view-manage-release-zones'
import ViewManageSystemSettings from 'features/view/manage/system/settings/view-manage-system-settings'
import ViewMediaResourcesComponent from 'features/view/media/resources/component/view-media-resources-component'
import ViewMediaThumbnail from 'features/view/media/thumbnail/view-media-thumbnail'
import ViewMediaVideo from 'features/view/media/video/view-media-video'
import ViewMetricConfigurationComponent from 'features/view/metric/configuration/component/view-metric-configuration-component'
import ViewMetricGraphsComponent from 'features/view/metric/graphs/component/view-metric-graphs-component'
import ViewMobileConnectComponent from 'features/view/mobile/connect/component/view-mobile-connect-component'
import ViewMobileLoginComponent from 'features/view/mobile/login/component/view-mobile-login-component'
import ViewPlayerAccessListComponent from 'features/view/player/access/list/component/view-player-access-list-component'
import ViewPlaywatchkidsMobileComponent from 'features/view/playwatchkids/mobile/component/view-playwatchkids-mobile-component'
import ViewPreviewCoherentScreen from 'features/view/preview/coherent/screen/view-preview-coherent-screen'
import ViewProcessingDashboardComponent from 'features/view/processing/dashboard/component/view-processing-dashboard-component'
import ViewProfileCommandsComponent from 'features/view/profile/commands/component/view-profile-commands-component'
import ViewProfileListComponent from 'features/view/profile/list/component/view-profile-list-component'
import ViewSearchScreenComponent from 'features/view/search/screen/component/view-search-screen-component'
import ViewSelectProfileComponent from 'features/view/select/profile/component/view-select-profile-component'
import ViewSelectProfileEditComponent from 'features/view/select/profile/edit/component/view-select-profile-edit-component'
import ViewSupportScreen from 'features/view/support/screen/view-support-screen'
import ViewSystemSchedules from 'features/view/system/schedules/view-system-schedules'
import ViewWatchMediaComponent from 'features/view/watch/media/component/view-watch-media-component'
import { ComponentGeneratorArgs, SetFormComponentTypes } from './build-form'
import { ComponentUITypes } from './standard'
export function SetupForm() {
  SetFormComponentTypes<any, any>(
    'jobs',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <Jobs {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'stripe-services',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <StripeServices {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-add-profile-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewAddProfileComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-anonymous-sign-in',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewAnonymousSignIn {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-api',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewApi {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-api-subtitles',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewApiSubtitles {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-approval-requests',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewApprovalRequests {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-creator-invitation-list',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentCreatorInvitationList {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-creator-invite',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentCreatorInvite {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-creator-profile-image',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentCreatorProfileImage {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouse {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-access-list-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseAccessListComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-list',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseList {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-media',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseMedia {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-membership',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseMembership {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-my-membership',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseMyMembership {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-profile-image',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseProfileImage {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-release-management',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseReleaseManagement {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-season',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseSeason {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-series',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseSeries {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-content-house-update',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewContentHouseUpdate {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-customer-administrator-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewCustomerAdministratorComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-customer-home-page-manager-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewCustomerHomePageManagerComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-customer-settings-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewCustomerSettingsComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-edit-profile-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewEditProfileComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-home-screen',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewHomeScreen {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-manage-coherent-screens',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewManageCoherentScreens {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-manage-curated-media',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewManageCuratedMedia {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-manage-curated-series',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewManageCuratedSeries {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-manage-release-zones',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewManageReleaseZones {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-manage-system-settings',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewManageSystemSettings {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-media-resources-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMediaResourcesComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-media-thumbnail',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMediaThumbnail {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-media-video',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMediaVideo {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-metric-configuration-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMetricConfigurationComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-metric-graphs-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMetricGraphsComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-mobile-connect-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMobileConnectComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-mobile-login-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewMobileLoginComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-player-access-list-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewPlayerAccessListComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-playwatchkids-mobile-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewPlaywatchkidsMobileComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-preview-coherent-screen',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewPreviewCoherentScreen {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-processing-dashboard-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewProcessingDashboardComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-profile-commands-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewProfileCommandsComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-profile-list-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewProfileListComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-search-screen-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewSearchScreenComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-select-profile-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewSelectProfileComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-select-profile-edit-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewSelectProfileEditComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-support-screen',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewSupportScreen {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-system-schedules',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewSystemSchedules {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    'view-watch-media-component',
    (args: ComponentGeneratorArgs<any, any>) => {
      return <ViewWatchMediaComponent {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.BUTTON,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <button {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.PHONENUMBER,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextField {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.ADDRESS,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextField {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.CHECKBOXFIELD,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickCheckboxField {...args} />
    },
  )

  SetFormComponentTypes<any, any>(
    ComponentUITypes.DROPDOWN,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickDropdown {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.STATE_PROVINCE,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickStateProvince {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.CAR_MAKE,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickDropdown {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.CAR_YEAR,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickDropdown {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.CAR_MODEL,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickDropdown {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.AGE,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickDropdown {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.LIST,
    (args: ComponentGeneratorArgs<any, any>) => {
      let list = args.list
      return <RedQuickList {...args}>{list}</RedQuickList>
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.SSN,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextField {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.DATETIME,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickDatePicker {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.CHECKBOX,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickCheckbox {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.TEXTAREA,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextArea {...args} />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.NUMBER,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextField {...args} type="number" />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.INT,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextField {...args} type="number" />
    },
  )
  SetFormComponentTypes<any, any>(
    ComponentUITypes.STRING,
    (args: ComponentGeneratorArgs<any, any>) => {
      return <RedQuickTextField {...args} />
    },
  )
}
